<template>
  <div class="cart-summary">
    <info-section
      v-if="
        promotionsSummary.promotion &&
        promotionApplied &&
        showInfoPromotionApplied
      "
      :title="$t('cart.discount_applied')"
      :subtitle="promotionApplied.label"
      :description="$t('cart.promomotions_summary_description')"
    >
      <line-item-promotion-summary
        :promotions-summary="promotionsSummary.promotion"
        :promotion-applied="promotionApplied"
      ></line-item-promotion-summary>
    </info-section>

    <items-summary
      v-if="summary"
      :summary="summary"
      :loading-shipping="loadingShipping"
      :free-shipping="isFreeShipping"
      :discount-total="discountTotal"
      :items-calcuted-promotion="promotionsSummary.items"
      @updateCart="updateCart"
    ></items-summary>

    <info-section
      v-if="Math.abs(discountTotal) !== 0"
      :title="$t('cart.economy')"
      :is-visible="true"
      :subtotal="discountTotal"
      svg='<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0,0,256,256">
                      <g fill="#f37053" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(2,2)"><path d="M80.89844,1.21875c-0.29785,0.00371 -0.59844,0.03203 -0.89844,0.08203c-12.1,1.9 -21.20039,11.99961 -21.90039,24.09961c0,0.2 -0.09961,0.39961 -0.09961,0.59961v18c0,1.4 -0.59961,2.69961 -1.59961,3.59961c-1,1 -2.40078,1.40078 -3.80078,1.30078c-2.6,-0.1 -4.59961,-2.40117 -4.59961,-5.20117v-5.39844c0,-2.6 -1.59961,-4.90117 -4.09961,-5.70117c-2.5,-0.8 -5.10117,-0.00039 -6.70117,2.09961l-11.59961,15.5c-6.7,8.9 -10.1,20.10078 -9.5,31.30078c1.2,24.6 21.5,44.5 46,45.5h1.90039c12.5,0 24.20078,-4.70039 33.30078,-13.40039c9.5,-9.1 14.69922,-21.39961 14.69922,-34.59961c0,-10.5 -3.29961,-20.40078 -9.59961,-28.80078l-17.30078,-22.69922c-3.5,-4.5 -3.49961,-10.9 -0.09961,-15.5l0.80078,-1.09961c1.4,-2 1.59883,-4.59961 0.29883,-6.59961c-1.1375,-2.0125 -3.11621,-3.10801 -5.20117,-3.08203zM51,62c5,0 9,4 9,9c0,5 -4,9 -9,9c-5,0 -9,-4 -9,-9c0,-5 4,-9 9,-9zM78.86328,63.98828c0.7625,-0.0625 1.53672,0.16094 2.13672,0.71094c1.2,1.1 1.40078,3.00117 0.30078,4.20117l-22,24.90039c-0.6,0.7 -1.40078,1 -2.30078,1c-0.7,0 -1.4,-0.20078 -2,-0.80078c-1.2,-1.1 -1.40078,-2.99922 -0.30078,-4.19922l22.10156,-24.80078c0.55,-0.6 1.3,-0.94922 2.0625,-1.01172zM51,68c-1.65685,0 -3,1.34315 -3,3c0,1.65685 1.34315,3 3,3c1.65685,0 3,-1.34315 3,-3c0,-1.65685 -1.34315,-3 -3,-3zM77,88c5,0 9,4 9,9c0,5 -4,9 -9,9c-5,0 -9,-4 -9,-9c0,-5 4,-9 9,-9zM77,94c-1.65685,0 -3,1.34315 -3,3c0,1.65685 1.34315,3 3,3c1.65685,0 3,-1.34315 3,-3c0,-1.65685 -1.34315,-3 -3,-3zM49,98c1.7,0 3,1.3 3,3c0,1.7 -1.3,3 -3,3c-1.7,0 -3,-1.3 -3,-3c0,-1.7 1.3,-3 3,-3z"></path></g></g>
                      </svg>'
    >
      <discount-summary
        :summary="summary"
        :promotion-applied="promotionApplied"
        :discount-total="discountTotal"
        :should-show-blinked-lost-adjustment="shouldShowBlinkedLostAdjustment"
        @updateCart="updateCart"
      >
      </discount-summary>
    </info-section>

    <info-section :title="$t('cart.coupon_code.apply_discount')">
      <coupon-code :is-new-cart="true" @updateCart="updateCart" />
    </info-section>

    <cart-total v-if="summary" :total="summary.total"></cart-total>
  </div>
</template>

<script>
import ItemsSummary from '~/components/cart/items-summary/ItemsSummary.vue'
import DiscountSummary from '~/components/cart/discount-summary/DiscountSummary.vue'
import CartTotal from '~/components/cart/cart-total/CartTotal.vue'
import CouponCode from '~/components/cart/coupon-code/CouponCode'
import InfoSection from '~/components/cart/info-section/InfoSection.vue'
import LineItemPromotionSummary from '~/components/line-item/line-item-promotion-summary/LineItemPromotionSummary.vue'

export default {
  components: {
    LineItemPromotionSummary,
    InfoSection,
    DiscountSummary,
    CartTotal,
    ItemsSummary,
    CouponCode,
  },
  props: {
    promotionApplied: {
      type: Object,
      required: true,
    },
    summary: {
      type: Object,
      required: true,
    },
    promotionsSummary: {
      type: Object,
      required: true,
    },
    loadingShipping: {
      type: Boolean,
      default: false,
    },
    isFreeShipping: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    subtotalWithBlinkedLost() {
      if (!this.summary) return
      return (
        Math.abs(parseFloat(this.promotionApplied?.total || 0)) +
        Math.abs(parseFloat(this.summary?.itemTotal || 0))
      )
    },
    shouldShowBlinkedLostAdjustment() {
      if (
        /^(Piscou, perdeu!|blinked, you lose!)$/.test(
          this.promotionApplied?.label
        ) &&
        Math.abs(parseFloat(this.promotionApplied?.total || 0)) !== 0
      ) {
        return true
      } else {
        return false
      }
    },
    discountTotal() {
      if (this.summary.itemTotal) {
        return (
          (Math.abs(parseFloat(this.summary.adjustmentDiscount)) +
            Math.abs(parseFloat(this.promotionApplied?.total || 0))) *
          -1
        )
      } else {
        return Number(this.summary.adjustmentDiscount)
      }
    },
    showInfoPromotionApplied() {
      return (
        this.promotionApplied &&
        Math.abs(parseFloat(this.promotionApplied?.total || 0)) !== 0 &&
        Math.abs(parseFloat(this.summary.subtotalWithBlinkedLost)) !== 0
      )
    },
  },
  methods: {
    updateCart(cart) {
      this.$emit('updateCart', cart)
    },
  },
}
</script>

<style lang="scss" scoped>
.cart-summary {
  width: 100%;
}
</style>
